// if unauthorized then redirect to login page
var typingTimer;                //timer identifier

$(document).ajaxError(function (e, xhr) {
	if (xhr.status === 401) {
		window.location = '/login';
	}
});

// viewportUnitsBuggyfill removed: the library was never loaded (vw/vh units
// are natively supported in all browsers since 2015). The call was throwing a
// silent TypeError on every page load.

$.fn.exists = function () {
	if (!this.length) {
		throw new Error("No elements matched by " + this.selector);
	}
	return this;
};

// Inject calendar icons into .jquery-datepicker wrappers.
// Called at page load and whenever a Foundation reveal modal opens
// (modals are the only place where .jquery-datepicker elements are
// injected dynamically). Replaces the deprecated DOMNodeInserted event,
// which was removed in Chrome 124+ and fires on every DOM mutation.
function initDatepickerIcons(context) {
	$(context || document).find('.jquery-datepicker').each(function () {
		if ($(this).find('img').length === 0) {
			$(this).append('<img src="/assets/calendar_2.gif" />');
		}
	});
}

jQuery(document).ready(function () {
	// Use sparklines plugin to generate charts (guard: plugin may not be loaded)
	if ($.fn.sparkline) {
		$('.sparkline').sparkline('html', {
			disableTooltips: true,
			highlightLineColor: null
		});
	}

	$('.toggle-hidden-inside').click(function () {
		$(this).parent().find('.hidden-content').slideToggle();
		$(this).parent().toggleClass('expanded');
	});

	// Initial sweep for datepicker icons on page load.
	initDatepickerIcons();

	// Re-run when any Foundation reveal modal finishes opening —
	// this is the only scenario where .jquery-datepicker is injected dynamically.
	$(document).on('opened.fndtn.reveal', '[data-reveal]', function () {
		initDatepickerIcons(this);
	});

	// button to close mobile top bar menu
	$('#close-top-bar').click(function () {
		$('.top-bar').removeClass('expanded');
	});

	$('body').on('mouseenter mouseleave', '.jquery-datepicker input', function () {
		var minDate = $(this).attr('minDate') === undefined ? 0 : $(this).attr('minDate');
		var maxDate = $(this).attr('maxDate') === undefined ? false : $(this).attr('maxDate');
		var timepicker = ($(this).attr('time') === undefined || $(this).attr('time') === 'false') ? false : true;
		var format = timepicker === true ? 'M d, Y h:i a' : 'M d, Y';
		var formatTime = 'h:i a';

		$(this).datetimepicker({
			closeOnDateSelect: true,
			// closeOnWithoutClick: false,
			minDate: minDate,
			maxDate: maxDate,
			timepicker: timepicker,
			format: format,
			formatTime: formatTime,
			step: 15
		});
	});
	$('.jquery-datepicker input').mouseover();

	$('body').on('click', '.jquery-datepicker img', function () {
		$(this).closest('.jquery-datepicker').find('input').datetimepicker('show');
	});

	// more-handle visibility (profile description)
	if ($('.inner-desc .inner-desc2').height() > $('.inner-desc').height()) {
		$('.inner-desc').addClass('overflow-fade');
		$('.more-handle').css({ 'display': 'inline-block' });
	}

	// more-handle click event (profile description)
	$('.more-handle > a').on('click', function () {
		if ($('.inner-desc').hasClass('overflow-fade')) {
			$('.inner-desc').addClass('open');
			$('.inner-desc').removeClass('overflow-fade');
			$(this).html("Show less");
		} else {
			$('.inner-desc').removeClass('open');
			$('.inner-desc').addClass('overflow-fade');
			$(this).html("View full text");
		}
	});

	// close handles click event
	$('.verification-finish a.close').on('click', function () {
		$('.verification-finish').hide();
	});

});

var showFlashMessage = function (message, klass) {
	$('.alert-box').remove();
	const flashMessage = `<div class="alert-box nomargin ${klass}" data-alert> ${message}` +
		'<a class="close"><i class="pti pt-cancel" href="#"></i></a>' +
		'</div>';
	return $('body').append(flashMessage);
}

var appendLoader = function (selector) {

	// var selector = $('#search-options')

	if (typeof selector == 'undefined') {

		var docHeight = $(window).height();
		$("body").append("<div id='overlay'><div class='spinner'></div></div>").addClass('modal-open')
		$("#overlay")
			.height(docHeight)
			.css({
				'opacity': 1,
				'position': 'fixed',
				'top': 0,
				'left': 0,
				'background-color': 'rgba(136,136,136, 0.85)',
				'width': '100%',
				'z-index': 5000,
			})
			.children('.spinner').css({
				'top': docHeight / 2
			});
	}
	else {

		var elemHeight = $(selector).outerHeight();
		$(selector).append("<div class='loader-overlay'><div class='spinner'></div></div>");
		$(".loader-overlay")
			.height(elemHeight)
			.css({
				'opacity': 1,
				'position': 'absolute',
				'top': 0,
				'left': 0,
				'background-color': 'rgba(153,153,153, 0.9)',
				'width': '100%',
				'z-index': 5,
			})
			.children('.spinner').css({
				'top': elemHeight / 2
			});
	}
};

// Gets param value from the URL
function getURLParameter(name) {
	return decodeURI(
		(RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [, null])[1]
	).replace(/\+/g, " ");
}

var destroyLoader = function () {
	$("body #overlay").remove();
	$("body .loader-overlay").remove();
	$("body").removeClass('modal-open');
	enable_ajaxify_parsley();
};

// Expose for cross-module access (Sprockets global → esbuild module scope fix)
window.getURLParameter = getURLParameter;
window.showFlashMessage = showFlashMessage;
window.appendLoader = appendLoader;
window.destroyLoader = destroyLoader;
